import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
const VideoConferences = lazy(() => import('./VideoConferences'));

const VideoConferencesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/video-conferences',
      element: <VideoConferences />,
    },
  ],
};

export default VideoConferencesConfig;
